module.exports = __webpack_public_path__ + "static/media/Nurse_working_with_Curoflow_telemedicine_platform_in_a_primary_care_clinic.9053f106.webp";